import { render } from "./newRegistrationWithYourCode.vue?vue&type=template&id=3824d8a1&ts=true"
import script from "./newRegistrationWithYourCode.vue?vue&type=script&lang=ts"
export * from "./newRegistrationWithYourCode.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__